<div class="chat-message" [class.user]="message.role === 'user'" [class.assistant]="message.role === 'assistant'">
  <!-- Avatar -->
  <div class="avatar">
    @if (message.role === 'user') {
      <span>👤</span>
    }
    @if (message.role === 'assistant') {
      <span>🤖</span>
    }
  </div>

  <!-- Bubble -->
  <div class="bubble">
    <!-- BILL-3055: los mensajes del asistente interpretan Markdown (sanitizado con DOMPurify);
         los mensajes del usuario siguen interpolados como texto plano, sin razon de negocio
         para interpretar Markdown en lo que el usuario mismo escribio. -->
    @if (message.role === 'assistant') {
      <div class="text markdown" [innerHTML]="renderedText"></div>
    } @else {
      <p class="text">{{ message.text }}</p>
    }

    <span class="timestamp">{{ formattedTime }}</span>
  </div>
</div>
